/**
 * ============================================
 * 产品对比功能 - 优化版本
 * 功能：产品对比管理、Cookie操作、UI更新
 * 版本：3.0 - 性能优化 + 代码重构
 * ============================================
 */

(function($) {
  'use strict';

  // ============================================
  // 1. 配置常量
  // ============================================
  const CONFIG = {
    COOKIE_NAME: 'compare',
    COOKIE_DAYS: 1,
    COOKIE_SEPARATOR: '__',
    COMPARE_PAGE_PATH: '/pages/compare',
    LANGUAGE_PATHS: {
      ar: '/ar',
      es: '/es',
      de: '/de',
      fr: '/fr'
    },
    SELECTORS: {
      productCard: '.product-card',
      compareInput: '.pro-compare input',
      compareWrapper: '.pro-compare',
      compareRemove: '.compare-prod-remove',
      compareWrap: '.compare-wrap',
      compareScroll: '.pro-compare-section .pro-compare-wrap .pro-compare-scroll',
      clearAllBtn: '.pro-compare-section .clear-all-compare'
    }
  };

  // ============================================
  // 2. Cookie工具
  // ============================================
  const CookieManager = {
    /**
     * 设置Cookie
     */
    set(name, value, days = CONFIG.COOKIE_DAYS) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = `; expires=${date.toUTCString()}`;
      }
      document.cookie = `${name}=${value || ''}${expires}; path=/`;
    },

    /**
     * 获取Cookie
     */
    get(name) {
      const nameEQ = `${name}=`;
      const cookies = document.cookie.split(';');
      for (const cookie of cookies) {
        let c = cookie.trim();
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length);
        }
      }
      return null;
    },

    /**
     * 删除Cookie
     */
    remove(name) {
      document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    },

    /**
     * 获取对比产品列表
     */
    getList() {
      const cookie = this.get(CONFIG.COOKIE_NAME);
      return cookie ? cookie.split(CONFIG.COOKIE_SEPARATOR) : [];
    },

    /**
     * 保存对比产品列表
     */
    saveList(handles) {
      const value = handles.length > 0 ? handles.join(CONFIG.COOKIE_SEPARATOR) : '';
      this.set(CONFIG.COOKIE_NAME, value);
    },

    /**
     * 添加产品到对比列表
     */
    add(handle) {
      const list = this.getList();
      if (!list.includes(handle)) {
        list.push(handle);
        this.saveList(list);
      }
      return list;
    },

    /**
     * 从对比列表移除产品
     */
    remove(handle) {
      let list = this.getList();
      list = list.filter(item => item !== handle);
      this.saveList(list);
      return list;
    },

    /**
     * 切换产品对比状态
     */
    toggle(handle) {
      const list = this.getList();
      const index = list.indexOf(handle);
      if (index > -1) {
        list.splice(index, 1);
      } else {
        list.push(handle);
      }
      this.saveList(list);
      return list;
    }
  };

  // ============================================
  // 3. 语言工具
  // ============================================
  const LanguageManager = {
    /**
     * 获取当前语言前缀
     */
    getPrefix() {
      const path = window.location.pathname;
      for (const [lang, prefix] of Object.entries(CONFIG.LANGUAGE_PATHS)) {
        if (path.includes(prefix)) {
          return prefix;
        }
      }
      return '';
    },

    /**
     * 获取对比页面URL
     */
    getCompareUrl() {
      const prefix = this.getPrefix();
      return window.location.origin + prefix + CONFIG.COMPARE_PAGE_PATH;
    },

    /**
     * 获取产品对比视图URL
     */
    getProductCompareUrl(handle) {
      const prefix = this.getPrefix();
      return `${prefix}/products/${handle}?view=for_compare`;
    }
  };

  // ============================================
  // 4. 对比管理器
  // ============================================
  const CompareManager = {
    /**
     * 初始化对比功能
     */
    init() {
      this._initActiveStates();
      this._initComparePage();
      this._bindEvents();
    },

    /**
     * 初始化激活状态
     */
    _initActiveStates() {
      const handles = CookieManager.getList();
      if (handles.length === 0) return;

      $(CONFIG.SELECTORS.productCard).each(function() {
        const $card = $(this);
        const handle = $card.find(CONFIG.SELECTORS.compareInput).attr('pro-handle');
        if (handles.includes(handle)) {
          $card.find(CONFIG.SELECTORS.compareInput).addClass('compare_active');
          $card.find(CONFIG.SELECTORS.compareWrapper).addClass('active');
        }
      });
    },

    /**
     * 初始化对比页面
     */
    _initComparePage() {
      const compareUrl = LanguageManager.getCompareUrl();
      if (window.location.href === compareUrl) {
        const handles = CookieManager.getList();
        if (handles.length > 0) {
          this._loadCompareProducts(handles);
        }
      }
    },

    /**
     * 加载对比产品
     */
    _loadCompareProducts(handles) {
      const $container = $(CONFIG.SELECTORS.compareScroll);
      let html = '';
      let completed = 0;

      handles.forEach((handle, index) => {
        const url = LanguageManager.getProductCompareUrl(handle);
        
        $.ajax({
          url: url,
          type: 'GET',
          success: function(data) {
            html += data;
          },
          complete: function() {
            completed++;
            if (completed === handles.length) {
              $container.html(html);
            }
          }
        });
      });
    },

    /**
     * 绑定事件
     */
    _bindEvents() {
      // ===== 对比复选框变化 =====
      $(document).on('change', CONFIG.SELECTORS.compareInput, function() {
        const $input = $(this);
        const handle = $input.attr('pro-handle');
        
        CookieManager.toggle(handle);
        $input.toggleClass('compare_active');
        $input.parents(CONFIG.SELECTORS.compareWrapper).toggleClass('active');
      });

      // ===== 对比复选框点击（跳转对比页面） =====
      $(document).on('change', `${CONFIG.SELECTORS.compareInput}.compare_active`, function() {
        const url = LanguageManager.getCompareUrl();
        window.location.href = url;
      });

      // ===== 单个产品移除 =====
      $(document).on('click', CONFIG.SELECTORS.compareRemove, function() {
        const $wrap = $(this).closest(CONFIG.SELECTORS.compareWrap);
        const handle = $wrap.attr('data-handle');
        
        if (handle) {
          CookieManager.remove(handle);
          $wrap.remove();
          
          // 更新UI状态
          $(CONFIG.SELECTORS.productCard).each(function() {
            const $card = $(this);
            const cardHandle = $card.find(CONFIG.SELECTORS.compareInput).attr('pro-handle');
            if (cardHandle === handle) {
              $card.find(CONFIG.SELECTORS.compareInput).removeClass('compare_active');
              $card.find(CONFIG.SELECTORS.compareWrapper).removeClass('active');
            }
          });
        }
      });

      // ===== 清空所有对比 =====
      $(document).on('click', CONFIG.SELECTORS.clearAllBtn, function(event) {
        event.preventDefault();
        CookieManager.remove(CONFIG.COOKIE_NAME);
        $(CONFIG.SELECTORS.compareScroll).html('');
        
        // 重置所有产品卡片的对比状态
        $(CONFIG.SELECTORS.productCard).each(function() {
          $(this).find(CONFIG.SELECTORS.compareInput).removeClass('compare_active');
          $(this).find(CONFIG.SELECTORS.compareWrapper).removeClass('active');
        });
      });
    },

    /**
     * 获取对比数量
     */
    getCount() {
      return CookieManager.getList().length;
    },

    /**
     * 检查产品是否在对比列表中
     */
    isInCompare(handle) {
      return CookieManager.getList().includes(handle);
    }
  };

  // ============================================
  // 5. 暴露公共API
  // ============================================
  window.CompareManager = {
    init: () => CompareManager.init(),
    getCount: () => CompareManager.getCount(),
    isInCompare: (handle) => CompareManager.isInCompare(handle),
    getList: () => CookieManager.getList(),
    add: (handle) => CookieManager.add(handle),
    remove: (handle) => CookieManager.remove(handle),
    toggle: (handle) => CookieManager.toggle(handle)
  };

  // ============================================
  // 6. 初始化
  // ============================================
  $(document).ready(function() {
    CompareManager.init();
  });

})(jQuery);